import { useTranslation } from "react-i18next";
import SensitivityModal from "./SensitivityModal";

interface Props {
  isOpen: boolean;
  setIsOpen: any;
}

const PointerSpeedModal = (props: Props) => {
  const { t } = useTranslation();

  return (
    <SensitivityModal
      title={t("touch:title_pointerspeed")}
      p1={t("touch:p1_pointerspeed")}
      p2={t("touch:p2_pointerspeed")}
      p3={t("touch:p3_pointerspeed")}
      isOpen={props.isOpen}
      setIsOpen={props.setIsOpen}
    />
  );
};

export default PointerSpeedModal;
